import React from 'react';
import { LayoutGrid, CalendarRange, List, Activity } from 'lucide-react';

export type AgendaView = 'month' | 'week' | 'list' | 'timeline';

interface Props {
  view: AgendaView;
  setView: (v: AgendaView) => void;
}

const OPTS: { k: AgendaView; label: string; Icon: React.ComponentType<{ className?: string; size?: number }> }[] = [
  { k: 'month',    label: 'Mês',      Icon: LayoutGrid },
  { k: 'week',     label: 'Semana',   Icon: CalendarRange },
  { k: 'list',     label: 'Lista',    Icon: List },
  { k: 'timeline', label: 'Timeline', Icon: Activity },
];

export function ViewSwitcher({ view, setView }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="Visualização da agenda"
      className="flex items-center gap-0.5 p-1 rounded-lg bg-surface-alt dark:bg-surface-dark-alt border border-line dark:border-line-dark"
    >
      {OPTS.map(o => {
        const active = view === o.k;
        return (
          <button
            key={o.k}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={o.label}
            title={`${o.label} (${o.k[0].toUpperCase()})`}
            onClick={() => setView(o.k)}
            className={[
              'inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md text-[12px] font-medium transition-colors',
              active
                ? 'bg-surface dark:bg-surface-dark text-ink-title dark:text-ink-title-dark shadow-sm-warm dark:shadow-sm-dark'
                : 'text-ink-subtitle dark:text-ink-subtitle-dark hover:text-ink-title dark:hover:text-ink-title-dark',
            ].join(' ')}
          >
            <o.Icon size={14} />
            <span className="hidden md:inline">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
